import {createContext, PropsWithChildren, useState, useCallback, useContext, useRef} from 'react';

interface ToastState {
    visible: boolean;
    message: string;
}

interface ToastContextType {
    toast: ToastState;
    showToast: (message: string) => void;
}

const defaultState: ToastState = {visible: false, message: ''};

const ToastContext = createContext<ToastContextType>({
    toast: defaultState,
    showToast: () => {},
});

export const ToastProvider = ({children}: PropsWithChildren) => {
    const [toast, setToast] = useState<ToastState>(defaultState);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const showToast = useCallback((message: string) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setToast({visible: true, message});
        timerRef.current = setTimeout(() => {
            setToast(defaultState);
        }, 3000);
    }, []);

    return (
        <ToastContext.Provider value={{toast, showToast}}>
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
